<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>会员管理</el-breadcrumb-item>
        <el-breadcrumb-item>运动处方</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
<div>
        <div id="pdf-content" class="prescription-container">
          <h1>运动处方</h1>

          <table class="info-table">
            <tr>
              <td>姓名</td>
              <td>{{ formData.name }}</td>
              <td>性别</td>
              <td>{{ formData.gender }}</td>
              <td>年龄</td>
              <td>{{ formData.age }}</td>
              <td>联系电话</td>
              <td>{{ formData.phone }}</td>
            </tr>
            <tr>
              <td>身份证</td>
              <td colspan="3">{{ formData.idNumber }}</td>
              <td>病史</td>
              <td>{{ formData.medicalHistory }}</td>
              <td>使用药物</td>
              <td>{{ formData.medication }}</td>
            </tr>
          </table>

          <div class="section">
            <h2>运动前筛查</h2>
            <p>
              <strong>体力活动水平:</strong>
              <span style="padding-left: 20mm">
                ■{{ formData.activityLevel }}</span
              >
              <span style="padding-left: 20mm"> □ 一般</span>
              <span style="padding-left: 20mm"> □ 正常</span>
            </p>
            <strong>健康筛查:</strong>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 15mm">
                <strong>身高:</strong> {{ formData.height }} cm
              </span>
              <span style="width: 40mm">
                <strong>体重:</strong> {{ formData.weight }} kg
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 15mm">
                <strong>空腹血糖:</strong>
              </span>
              <span style="width: 40mm">
                <strong>血压:</strong>
              </span>
              <span style="width: 40mm">
                <strong>脉搏:</strong>
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 15mm">
                <strong>总胆固醇:</strong>
              </span>
              <span style="width: 40mm">
                <strong>甘油三脂:</strong>
              </span>
              <span style="width: 45mm">
                <strong>高密度脂蛋白:</strong>
              </span>
              <span style="width: 45mm">
                <strong>低密度脂蛋白:</strong>
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 15mm">
                <strong>体脂率:</strong>
              </span>
              <span style="width: 40mm">
                <strong>脂肪量:</strong>
              </span>
              <span style="width: 45mm">
                <strong>肌肉量：:</strong>
              </span>
              <span style="width: 45mm">
                <strong>内脏脂肪面积:</strong>
              </span>
            </p>
          </div>

          <div class="section">
            <h2>运动医学检查</h2>
            <p>
              <strong>运动风险等级:</strong>
              <span style="padding-left: 20mm"> ■ 低</span>
              <span style="padding-left: 20mm"> □ 中</span>
              <span style="padding-left: 20mm"> □ 高</span>
            </p>
            <p><strong>运动测试结果:</strong></p>
            <p>
              <span style="margin-left: 15mm">
                <strong>心肺机能:</strong>
                <span style="padding-left: 10mm"> ■ 差</span>
                <span style="padding-left: 10mm"> □ 较差</span>
                <span style="padding-left: 10mm"> □ 一般</span>
                <span style="padding-left: 10mm"> □ 良好</span>
                <span style="padding-left: 10mm"> □ 优秀</span>
              </span>
            </p>
            <p>
              <span style="margin-left: 15mm">
                <strong>肌肉力量:</strong>
                <span style="padding-left: 10mm"> ■ 差</span>
                <span style="padding-left: 10mm"> □ 较差</span>
                <span style="padding-left: 10mm"> □ 一般</span>
                <span style="padding-left: 10mm"> □ 良好</span>
                <span style="padding-left: 10mm"> □ 优秀</span>
              </span>
            </p>
            <p>
              <span style="margin-left: 15mm">
                <strong>体成分:</strong>
                <span style="padding-left: 14mm"> ■ 差</span>
                <span style="padding-left: 10mm"> □ 较差</span>
                <span style="padding-left: 10mm"> □ 一般</span>
                <span style="padding-left: 10mm"> □ 良好</span>
                <span style="padding-left: 10mm"> □ 优秀</span>
              </span>
            </p>
          </div>

          <div class="section">
            <h2>运动处方</h2>
            <p>
              <strong>运动目的:</strong>
            </p>
            <p style="font-size: 13px">
              <span style="padding-left: 2mm"> ■ 降低血压</span>
              <span style="padding-left: 2mm"> □ 调整血脂</span>
              <span style="padding-left: 2mm"> □ 降低血糖</span>
              <span style="padding-left: 2mm"> ■ 减重</span>
              <span style="padding-left: 2mm"> □ 增加心肺耐力</span>
              <span style="padding-left: 2mm"> □ 增加肌肉力量</span>
              <span style="padding-left: 2mm"> □ 增加身体柔韧性和平衡性</span>
            </p>
            <p>
              <span>
                <strong>机构运动项目:</strong>
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>二头/三头肌训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 1档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 21个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>上推/下拉训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 2档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 24个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>推胸划船训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 3档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 23个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>腹肌/背肌训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 3档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 20个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>大腿内外侧肌训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 2档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 20个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>踢腿/勾腿训练:</strong>
              </span>
              <span style="padding-left: 5mm"> 3档</span>
              <span style="padding-left: 10mm"> 4组</span>
              <span style="padding-left: 10mm"> 20个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>运动强度:</strong>
              </span>
              <span style="padding-left: 5mm"> ■ 低</span>
              <span style="padding-left: 10mm"> □ 中</span>
              <span style="padding-left: 10mm"> □ 高</span>
            </p>

            <p>
              <span>
                <strong>居家运动项目:</strong>
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>水瓶直臂侧平举:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">16个/组</span>
              <span style="width: 30mm; margin-left: 15mm">
                <strong>贝壳式:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">16个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>对墙俯卧撑:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">12个/组</span>
              <span style="width: 30mm; margin-left: 15mm">
                <strong>靠墙下蹲:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">16个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>坐姿弹力带划船:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">13个/组</span>
              <span style="width: 30mm; margin-left: 15mm">
                <strong>仰卧挺髋:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">16个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>仰卧交叉腿:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">13个/组</span>
            </p>
            <p style="display: flex">
              <span style="width: 40mm; margin-left: 20mm">
                <strong>侧平举小燕飞:</strong>
              </span>
              <span style="padding-left: 5mm">4组</span>
              <span style="padding-left: 5mm">14个/组</span>
            </p>
            <p>
              <span>
                <strong>运动计划:</strong>
              </span>
            </p>
            <p style="display: flex">
              <span style="width: 20mm; margin-left: 20mm">
                <strong>适应期:</strong>
              </span>
              <span style="padding-left: 5mm">运动时间:3-4周</span>
              <span style="padding-left: 5mm">运动频率:3-4次/周</span>
              <span style="padding-left: 5mm">目标能耗:--</span>
            </p>
            <p style="display: flex">
              <span style="width: 20mm; margin-left: 20mm">
                <strong>强化期:</strong>
              </span>
              <span style="padding-left: 5mm">运动时间:5-8周</span>
              <span style="padding-left: 5mm">运动频率:3-5次/周</span>
              <span style="padding-left: 5mm">目标能耗:--</span>
            </p>
            <p style="display: flex">
              <span style="width: 20mm; margin-left: 20mm">
                <strong>稳定期:</strong>
              </span>
              <span style="padding-left: 5mm">运动时间:9-12周</span>
              <span style="padding-left: 5mm">运动频率:5-6次/周</span>
              <span style="padding-left: 5mm">目标能耗:--</span>
            </p>
          </div>

          <p>
              <span>
                <strong>注意事项:</strong>
              </span>
              <ol>
              <li v-for="(note, index) in formData.notes" :key="index">
                {{ note }}
              </li>
            </ol>
            </p>

          <!-- 签名 -->
          <div class="signature">
            <p>运动处方师:</p>
            <p>回访时间: </p>
            <!-- <p>运动处方师: {{ formData.doctor }}</p>
            <p>回访时间: {{ formData.followUpDate }}</p> -->
          </div>
        </div>
      </div>

      <div class="pdf-options">
        <el-form label-width="120px">
          <el-form-item label="文件名称">
            <el-input
              v-model="pdfOptions.filename"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="页面方向">
            <el-radio-group v-model="pdfOptions.jsPDF.orientation">
              <el-radio label="portrait">纵向</el-radio>
              <!-- <el-radio label="landscape">横向</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="页面尺寸">
            <el-select
              v-model="pdfOptions.jsPDF.format"
              placeholder="请选择页面尺寸"
            >
              <el-option label="A4 (210×297mm)" value="a4"></el-option>
              <!-- <el-option label="A5 (148×210mm)" value="a5"></el-option>
              <el-option label="Letter (216×279mm)" value="letter"></el-option>
              <el-option label="自定义" value="custom"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item
            label="边距(mm)"
            v-if="pdfOptions.jsPDF.format === 'custom'"
          >
            <el-input-number
              v-model="pdfOptions.margin"
              :min="0"
              :max="50"
            ></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="generatePDF">生成PDF</el-button>
        </span>
      </div>

    <!-- <el-button type="primary" @click="dialogVisible = true">生成PDF</el-button>
    <el-dialog
      title="生成PDF选项"
      :visible.sync="dialogVisible"
      width="340mm"
      class="my-dialog-class"
      :top="'1%'"
    >
    </el-dialog> -->
  </basic-container>
</template>

<script>
import { getMotion } from "@/api/health/manage";
import { mapGetters } from "vuex";
import html2pdf from "html2pdf.js";

export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // span: 12,
        // labelWidth: 150,
        tip: false,
        border: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: "姓名",
            prop: "name",
            detail: true,
          },
          {
            label: "年龄",
            prop: "age",
            detail: true,
          },
          {
            label: "基础疾病",
            prop: "base_disease",
            detail: true,
            // search: true
          },
          {
            label: "病程",
            prop: "course_disease",
            detail: true,
            // search: true
          },
          {
            label: "管理目标",
            prop: "manage_target",
            detail: true,
            // search: true
          },
          {
            label: "管理目标",
            prop: "manage_target",
            detail: true,
            // search: true
          },
          {
            label: "运动干预前体重",
            prop: "before_weight",
            detail: true,
            // labelWidth: 250,
            // search: true
          },
          {
            label: "运动干预前舒张压(mmHg)",
            prop: "before_dia",
            detail: true,
            // search: true
          },
          {
            label: "运动干预前收缩压(mmHg)",
            prop: "before_sys",
            detail: true,
            // search: true
          },
          {
            label: "运动干预前空腹血糖(mmol/L)",
            prop: "before_kf_bs",
            detail: true,
            // search: true
          },
          {
            label: "运动干预前糖化血红蛋白糖(%)",
            prop: "before_bs",
            detail: true,
            // search: true
          },
          {
            label: "运动干预前体脂肪率(%)",
            prop: "before_fat",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后体重(kg)",
            prop: "weight",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后舒张压(mmHg)",
            prop: "dia",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后收缩压(mmHg)",
            prop: "sys",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后空腹血糖(mmol/L)",
            prop: "kf_bs",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后糖化血红蛋白糖(%)",
            prop: "bs",
            detail: true,
            // search: true
          },
          {
            label: "运动干预后体脂肪率(%)",
            prop: "fat",
            detail: true,
            // search: true
          },
          {
            label: "干预时长(月)",
            prop: "duration",
            detail: true,
            // search: true
          },
        ],
      },
      reportOption1: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "姓名",
            prop: "name",
            detail: true,
          },
          {
            label: "年龄",
            prop: "age",
            detail: true,
          },
          {
            label: "体力",
            prop: "age",
            detail: true,
          },
          {
            label: "年龄",
            prop: "age",
            detail: true,
          },
        ],
      },
      data: [],
      showDialog: false, // 控制弹框显示
      formData: {
        name: "",
        gender: "女",
        age: 43,
        phone: "153****8212",
        idNumber: "320111198202*****",
        medicalHistory: "无疾病",
        medication: "",
        activityLevel: "不足",
        height: 162,
        weight: 86.9,
        exercisePurposes: [
          "降低血压",
          "调整血脂",
          "降低血糖",
          "减重",
          "增加心肺活力",
        ],
        institutionExercises: [
          {
            name: "二头/三头肌训练",
            level: "1档",
            sets: "4组",
            reps: "21个/组",
          },
          {
            name: "水瓶直筒侧平举",
            level: "2档",
            sets: "4组",
            reps: "24个/组",
          },
        ],
        notes: [
          "饭前饭后1小时内尽量不要运动",
          "锻炼后不应立即入浴、大汗淋漓时通低温，会使皮肤表层收缩，严重时引起闭汗症或静脉曲张",
        ],
        doctor: "周礼妹",
        followUpDate: new Date().toLocaleDateString(),
      },
      dialogVisible: false,
      pdfOptions: {
        margin: 10,
        filename: "运动处方.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      console.log(wxUserId);
      getMotion(wxUserId).then((res) => {
        this.data = res.data;
        console.log(res.data[0]);
        this.pdfOptions.filename = "运动处方_" + res.data[0].name;
        this.formData.name = res.data[0].name;
        this.formData.age = res.data[0].age;
        if (res.data[0].sex === 2) this.formData.gender = "女";
        else if (res.data[0].sex === 1) this.formData.gender = "男";
        this.formData.phone = res.data[0].mobile;
        this.formData.idNumber = res.data[0].id_card;
        this.formData.height = res.data[0].height;
        this.formData.weight = res.data[0].weight;
      });
    },

    generatePDF() {
      this.showDialog = false; // 关闭弹框
      const element = document.getElementById("pdf-content");
      const opt = {
        margin: 0,
        filename: this.pdfOptions.filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf().from(element).set(opt).save();
    },
  },
};
</script>

<style scoped>
.my-dialog-class {
  display: flex;
  align-items: flex-start;
}

.prescription-container {
  font-family: "SimSun", "宋体", serif;
  width: 210mm;
  padding: 10mm;
  box-sizing: border-box;
  float: left;
}

.pdf-options {
  padding-left: 2%;
  float: left;
  width: 100mm;
}

h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.info-table td {
  border: 1px solid #000;
  padding: 8px;
  font-size: 14px;
}

.section {
  margin-bottom: 15px;
}

h2,
h3 {
  font-size: 18px;
  margin: 10px 0;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}

ul,
ol {
  margin-left: 20px;
}

.signature {
  text-align: right;
  margin-top: 40px;
}
</style>
